// Copyright (c) 2022 by Move Closer

export interface CurrencyConfig {
  cropZeros?: boolean
  currencyMap?: Record<string, string>
  defaultCode?: string
}

export const defaultCurrencyConfig = {
  cropZeros: false,
  defaultCode: 'zł',
  currencyMap: {
    PLN: 'zł'
  }
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const filterCurrencyFactory = (currency?: string, config?: CurrencyConfig) => {
  const currencyConfig = {
    ...defaultCurrencyConfig,
    ...config
  }
  let currencyCode = currency ?? currencyConfig?.defaultCode

  if (currencyConfig?.currencyMap && currencyConfig.currencyMap[currencyCode]) {
    currencyCode = currencyConfig.currencyMap[currencyCode]
  }

  return (value: unknown) => filterCurrency(value, currencyCode, currencyConfig)
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const filterCurrency = (value: unknown, currency: string, config: CurrencyConfig): string => {
  const candidate: number = typeof value !== 'number' ? parseFloat(String(value)) : value
  if (isNaN(candidate)) {
    return 'Invalid value'
  }

  let valueLabel = candidate.toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')

  if (config.cropZeros) {
    valueLabel = valueLabel.replace(',00', '')
  }

  return `${valueLabel} ${currency}`
}
